// appels/programme services
// Pure async functions only: no React, no hooks, no state. Parse at this boundary.
import { privateApi } from "@core/libs/axios";
import { parseWith } from "@core/parse";
import { AppelSchema, type Appel } from "../../_shared/types";
import type { ProgrammeValues } from "../types";
import { toProgrammeRequest } from "../types";

/**
 * `PUT /appels/{id}/steps/programme/`: replace the six texts and complete step 1. Needs the appel's
 * current `revision` (a stale one is refused with `409 appel_revision_conflict`) and an
 * `Idempotency-Key`: retry an uncertain save with the same key and payload. Only a draft can be
 * saved. The answer is the appel as it now is (step 1 completed, step 2 open).
 */
export async function saveProgramme(
  id: string,
  values: ProgrammeValues,
  expectedRevision: number,
  idempotencyKey: string
): Promise<Appel> {
  const path = `/appels/${id}/steps/programme/`;
  const dto = await privateApi
    .put<unknown>(
      path,
      { expected_revision: expectedRevision, ...toProgrammeRequest(values) },
      { headers: { "Idempotency-Key": idempotencyKey } }
    )
    .then((r) => r.data);
  return parseWith(AppelSchema, dto, `PUT ${path}`);
}
